// extracted by mini-css-extract-plugin
export default {"inputWrapper":"InputSearch_inputWrapper__rl9-u","label":"InputSearch_label__7L+R8","input":"InputSearch_input__k7E2E","icon":"InputSearch_icon__wnUc6"};